import React, { Component } from "react";
import { Editors, Formatters, Filters } from 'react-data-grid-addons';
import { numericFilter, textFilter, NumericFilter } from '../../lib/tableFilters';
import { dateSorter } from '../../lib/tableSorters';
import Waitable from '../Waitable';
import Table from '../../components/Table/TableV2';
import moment from 'moment';
import InvoiceTable from '../InvoiceTable'
// Import React Table
import ReactTable from "react-table";
import ReactDataGrid from 'react-data-grid';
import "react-table/react-table.css";
import { Row, Col } from 'reactstrap';
import { DateTimePicker } from 'react-widgets'


import momentLocalizer from 'react-widgets-moment';
import { encode } from "punycode";
import { toast } from "react-toastify";


moment.locale('en');
momentLocalizer();

const { AutoComplete: AutoCompleteEditor, DropDownEditor } = Editors;
const { DropDownFormatter } = Formatters;

const columns = [{
    Header: "User Info",
    columns: [
        {
            Header: "First Name",
            accessor: "firstName",
            filterMethod: textFilter
        },
        {
            Header: "Last Name",
            id: "lastName",
            accessor: d => d.lastName,
            filterMethod: textFilter
        },
        {
            Header: "Email",
            id: "email",
            accessor: d => d.email,
            filterMethod: textFilter
        }
    ]
},
{
    Header: "Quote Info",
    columns: [
        {
            accessor: "terminal",
            Header: "Origin Terminal",
            filterMethod: textFilter
        },
        {
            accessor: "createdAt",
            Header: "Quote Date",
            filterMethod: textFilter,
            Cell: row => row.value,//moment(row.value,"YYYY-MM-DD").format(),
            sortMethod: dateSorter
        },
        {
            accessor: "total",
            Header: "Total",
            Cell: row => `$${row.value}`,
            filterMethod: numericFilter,
            Filter: NumericFilter
        },
    ]
}
]

const sub = (row => {
    return (
        <div className='pl-5 pl-5'>
            <InvoiceTable quote={row.original.quote} terminalName={row.original.terminal} />
        </div>
    );
});


export default class ClientRateRequest extends Component {
    constructor(props) {
        super(props);

        this.onStartDateChanged = this.onStartDateChanged.bind(this);
        this.onEndDateChanged = this.onEndDateChanged.bind(this);

        this.state = {
            data: props.quotes.get("data") || [],
            startDate: props.initialStartDate,// moment().subtract(3, "months").format("YYYY-MM-DD"),
            endDate: props.initialEndDate //moment().format("YYYY-MM-DD")
        }
    }

    transform(clientsQuotes) {
        let newDate = clientsQuotes.map(data => {
            return {
                firstName: data.user.firstName,
                lastName: data.user.lastName,
                email: data.user.email,
                terminal: data.terminal.name,
                createdAt: moment(data.createdAt).format("MM-DD-YYYY, h:mm:ss a"),
                total: data.request.total,
                quote: data.request
            };
        })
        return newDate;
    }

    onStartDateChanged(value) {
        const { dispatchGetQuotes } = this.props;

        let startDate = moment(value);
        if (startDate.isValid()) {
            startDate = startDate.format("YYYY-MM-DD")
            this.setState({ startDate }, () => {
                dispatchGetQuotes({
                    startDate: this.state.startDate,
                    endDate: this.state.endDate
                }, (err, results) => {
                    if (err) {
                        toast.error(err.message);
                        /*
                        this.setState({
                            data: results
                        });
                        */
                    }
                })
            });
        }
        //.format("YYYY-MM-DD") ;

    }

    onEndDateChanged(value) {
        const { dispatchGetQuotes } = this.props;
        let endDate = moment(value).set("hour", 23).set("minute", 59).set("second", 59);
        if (endDate.isValid()) {
            endDate = endDate.format("YYYY-MM-DD HH:mm:ss");
            this.setState({ endDate }, (state) => {
                dispatchGetQuotes({
                    startDate: this.state.startDate,
                    endDate: this.state.endDate
                }, (err, results) => {

                    if (err) {
                        toast.error(err.message);
                        /*
                        this.setState({
                            data: results
                        });
                        */
                    }
                })
            });
        }

    }

    render() {

        const { quotes, initialStartDate, initialEndDate } = this.props;
        return (
            <Waitable entities={[quotes]}>
                <Row>
                    <Col className="pb-3">
                        Start Date
                <DateTimePicker
                            value={moment(this.state.startDate).toDate()}
                            defaultValue={moment(initialStartDate).toDate()}
                            time={false}
                            onChange={this.onStartDateChanged}
                        />
                    </Col>
                    <Col className="pb-3">
                        End Date
                <DateTimePicker
                            value={moment(this.state.endDate).toDate()}
                            defaultValue={moment(initialEndDate).toDate()}
                            onChange={this.onEndDateChanged}
                            time={false}
                        />
                    </Col>
                    <Col xs='12'>
                        <ReactTable
                            filterable
                            //data={this.transform(clientsQuotes.get('data'))}
                            className="-striped -highlight"
                            data={this.transform(/*this.state.data*/ this.props.quotes.get("data") || [])}
                            defaultPageSize={10}
                            columns={columns}
                            SubComponent={sub}
                        />
                    </Col>
                </Row>
            </Waitable>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ClientRateRequest/ClientRateRequest.js